<div #container class="sc-ace-text-container component-wrap">
  <mat-label
    #labelContainer
    (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ft-label"
    [title]="componentDefinition?.label">
      {{componentDefinition?.label}}
  </mat-label>

  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip, container, labelContainer)">
  </div>  

  <div [id]="'gblAceText'+fieldName" #elem class="form-group label-static">
    <div>
      <ace-editor
        [id]="fieldName" #editor
        [mode]="mode"
        [theme]="theme"
        [readOnly]="disabled"
        (textChanged)="onChange($event)"
        [durationBeforeCallback]="500"
        style="min-height: 200px; width:100%; overflow: auto;">
      </ace-editor>
    </div>
  </div>
</div>
